var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('creators-list-modal',_vm._b({staticClass:"likes-modal",attrs:{"title":"Likes","creators":_vm.creators,"emptyMessage":"Post has no likes"}},'creators-list-modal',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }